import { TCreateReceiptBody, TCreateReceiptResponse } from "@elixir/types";
import { GET_TRYST_HOST, RECEIPT_DOMAIN } from "../constants/env";
import { TrystGenericResponse } from "../types/tryst";
import fetchWrapper from "../fetch-client";


export default async function updateReceiptForBusiness({
  businessId,
  receiptId,
  payload,
  meta,
  shouldGeneratePDF,
  abhaId,
}: {
  businessId: string | number;
  receiptId: number;
  shouldGeneratePDF?: boolean;
  abhaId?: string;
} & TCreateReceiptBody): Promise<TrystGenericResponse<TCreateReceiptResponse>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const Reqpayload: TCreateReceiptBody & { abhaId?: string } = {
      payload,
      meta,
      abhaId
    };
    const fileNameReceiptV2 = `v2/${businessId}/${meta.doctor_oid}/${meta.clinic_id}/${new Date().getTime()}.pdf`;
    if (shouldGeneratePDF) {
      Reqpayload["pdf_url"] = `${RECEIPT_DOMAIN()}/${fileNameReceiptV2}`;
    }
    const body = JSON.stringify(Reqpayload);

    const requestOptions: RequestInit = {
      method: "PUT",
      headers: myHeaders,
      body: body,
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };

    const response = await fetchWrapper(
      `${TRYST_HOST}/business/${businessId}/receipt/${receiptId}`,
      requestOptions
    );
    const result = await response?.json();
    return {
      ...(result || {}),
      generatedFileName: fileNameReceiptV2,
    };
  } catch (error) {
    return { success: false };
  }
}
